export default function QuickStats({ stats, isLoading }) {
  const items = [
    {
      name: 'Prospects enrichis',
      meta: 'Cette semaine',
      value: stats.recentProspects || 0,
    },
    {
      name: 'Recherches effectuées',
      meta: 'Cette semaine',
      value: stats.recentSearchesCount || 0,
    },
    {
      name: 'Crédits disponibles',
      meta: 'Solde actuel',
      value: (stats.currentCredits || 0).toLocaleString('fr-FR'),
    },
  ]

  return (
    <div className="campaigns-card">
      <div className="card-header">
        <h2>Statistiques rapides</h2>
      </div>
      <div className="campaigns-list">
        {items.map((item, i) => (
          <div key={i} className="campaign-item">
            <div className="campaign-info">
              <div className="campaign-name">{item.name}</div>
              <div className="campaign-stats">{item.meta}</div>
            </div>
            <div className="campaign-score">{isLoading ? '-' : item.value}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
